import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AddSolicitareRankInterface, UpdateSolicitareRankInterface } from './solicitare-rank.interface';
import { Observable, Subject, finalize } from 'rxjs';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class SolicitareRankService {
	private token!: string;
	private httpOptions: any;

	private basePath = environment.interop.basePath;
	private getSolicitareRankDTURL = this.basePath + environment.interop.platform.nomenclatoare.solicitareRank.listDT;
	private getSolicitareRankURL = this.basePath + environment.interop.platform.nomenclatoare.solicitareRank.list;
	private storeRankSolicitareURL = this.basePath + environment.interop.platform.nomenclatoare.solicitareRank.store;
	private updateRankSolicitareURL = this.basePath + environment.interop.platform.nomenclatoare.solicitareRank.update;
	private deleteRankSolicitareURL = this.basePath + environment.interop.platform.nomenclatoare.solicitareRank.delete;
	private confirmationRankSolicitareURL = this.basePath + environment.interop.platform.nomenclatoare.solicitareRank.confirmationAccount;
	private findRankSOlicitareURL = this.basePath + environment.interop.platform.nomenclatoare.solicitareRank.find;

	constructor(private http: HttpClient) { }

	getSolicitareRankDT() {
		return this.http.get(this.getSolicitareRankDTURL, this.httpOptions);
	}

	addSolicitareRank(data: AddSolicitareRankInterface) {
		return this.http.post(this.storeRankSolicitareURL, data, this.httpOptions);
	}

	getSolicitareRankById(id: number) {
		return this.http.get(this.findRankSOlicitareURL + id, this.httpOptions);
	}

	updateRankSolicitare(data: UpdateSolicitareRankInterface) {
		return this.http.put(this.updateRankSolicitareURL, data, this.httpOptions);
	}

	deleteRankSolicitare(data: number) {
		return this.http.delete(this.deleteRankSolicitareURL + data);
	}

	setToken(token: string) {
		this.token = token;
		this.httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${this.token}`,
			}),
		};
	}

	getRanksList() {
		return this.http
			.get<{ errors: boolean; data: any[]; status_code: number }>(
				this.getSolicitareRankURL
			)
			.pipe(
				map((response) =>
					response.data.map((item) => ({
						id: item.id_directie,
						name: item.name,
						slug: item.slug,
					}))
				),
				catchError((error) => {
					console.error('Error in get directii active:', error);
					return throwError(error);
				})
			);
	}
}
